module.exports = __webpack_public_path__ + "static/fonts/siyuanS.f983acb.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/siyuanS.otf
// module id = h4iB
// module chunks = 1